import { useTranslation } from '@exam-room/translations';
import { cn } from '@exam-room/utils';
import { useController } from 'react-hook-form';

import { RadioButton } from '../radio-button';

interface RadioGroupProps {
  name: string;
  options: { label: string | JSX.Element; value: string; endAdornment?: React.ReactNode }[];
  disabled?: boolean;
  className?: HTMLFieldSetElement['className'];
}

function RadioGroup(props: Readonly<RadioGroupProps>) {
  const { name, options, disabled, className } = props;

  const { t } = useTranslation();

  const {
    field: { ref: fieldRef },
    fieldState: { error },
  } = useController({ name });

  return (
    <fieldset
      className={cn(['text-text-primary flex flex-col items-start', className])}
      disabled={disabled}
      ref={(ref) => {
        fieldRef({
          focus: () => ref?.scrollIntoView({ block: 'center' }),
        });
      }}
    >
      {options.map((option) => (
        <div key={option.value}>
          <RadioButton
            id={name + option.value}
            disabled={disabled}
            name={name}
            value={option.value}
            label={typeof option.label === 'string' ? <p>{option.label}</p> : option.label}
            endAdornment={option.endAdornment}
          />
        </div>
      ))}
      {error && error?.message ? (
        <p className='text-danger w-full p-2 text-sm'>{t(error.message)}</p>
      ) : null}
    </fieldset>
  );
}

export default RadioGroup;
